


































































import axios from "axios";
import moment from "moment";
import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import Order, { OrderStatus } from "@/models/Order";
import OrderItem from "@/models/OrderItem";
import ordersService from "@/services/orders-service";
import OrdersRequestFilter from "@/models/OrdersRequestFilter";
import sumBy from "lodash/sumBy";
import map from "lodash/map";
import Extra from "@/models/Extra";
import restaurantsService from "@/services/restaurants-service";
import Restaurant from "@/models/Restaurant";

@Component
export default class OrderDetails extends Vue {
  @Prop()
  id!: number;

  order: Order = new Order();
  autoPrint = true;
  isLoading = false;

  orderStatusColor(status: OrderStatus) {
    return Order.orderStatusColor(status);
  }

  orderStatusText(status: OrderStatus) {
    return Order.orderStatusText(status);
  }

  orderTransportText(order: Order) {
    let result = "";
    if (order.transport == "pickup") {
      result += "Abholung";
    } else {
      result += "Lieferung";
    }
    if (order.preorder == 1) {
      result += " später";
    } else {
      result += " sofort";
    }
    return result;
  }

  paymentStatusText(status: number) {
    return Order.paymentStatusText(status);
  }

  async deliveryInAsync(minutes: number) {
    if (this.order) {
      this.isLoading = true;
      let dt = moment().add(minutes, "minutes");
      await ordersService.updateEstimateCompleteAsync(
        this.order.uid,
        dt.toDate()
      );
      this.order.pickup_date = dt.format("DD.MM.YYYY");
      this.order.pickup_time = dt.format("hh:mm");
      this.order.estimate_complete = dt.format("hh:mm");
      await this.loadAsync();
      this.isLoading = false;
      if (this.autoPrint) {
        await this.printAsync(this.order);
      }
    }
  }

  extras(extras: Extra[]) {
    let es: string[] = [];
    extras.forEach(e => {
      es.push(e.title);
    });
    return es.join(", ");
  }

  toDate(ts: number) {
    return new Date(ts * 1000);
  }

  toTime(ts: string) {
    if (!ts) {
      return "";
    }
    return moment(this.toDate(parseInt(ts))).format("HH:mm");
  }

  async printAsync(order: Order) {
    this.isLoading = true

    if (!order.restaurant) {
      order.restaurant =
        (await restaurantsService.findOneAsync(Vue.prototype.$uid)) ??
        new Restaurant();
    }

    // summarize dish price
    order.items.forEach(i => {
      i.dish.price += i.extras
        .map(e => e.price)
        .reduce((acc, curr) => acc + curr, 0);
      i.dish.price *= i.amount;
    });

    let data = {
      receiptSerialNumber: order.serialNumber,
      orderNumber: order.uid,
      restaurantName: order.restaurant.name,
      customerName: order.address.name,
      customerPhone: order.customer.telephone,
      customerId: order.customer.uid,
      addressLine1: order.address.address,
      addressLine2: "",
      zip: order.address.zip,
      city: order.address.city,
      note: order.address.note,
      paymentStatus: Order.paymentStatusText(order.payment_complete),
      paymentMethod: order.payment_method.name,
      paymentIdentifier: order.payment_method.identifier,
      estimateComplete: this.toTime(order.estimate_complete),
      isPreorder: order.preorder == 1,
      preorderDate: order.preorder_date,
      preorderTime: order.preorder_time,
      numberOfProducts: sumBy(order.items, i => i.amount),
      itemsSum: sumBy(order.items, i => i.price * i.amount),
      overallSum: order.total,
      items: order.items,
      isNewCustomer: order.new_customer == 1,
      isCopy: order.receipt_printed == 1,
      isPickup: order.transport == "pickup",
      isDelayed: order.transport != "delivery" || order.preorder == 1,
      deliveryCosts: order.real_delivery_costs,
      comment: order.comment
    };
    if (window.printer) {
      window.printer.Print(JSON.stringify(data));
    } else {
      console.log(JSON.stringify(data));
    }

    await ordersService.updateReceiptPrintedAsync(order.uid, true);
    await ordersService.updateStatusAsync(order.uid, OrderStatus.Closed);

    this.isLoading = false

    this.$router.push({ name: 'CurrentOrders' });
  }

  async mounted() {
    await this.loadAsync();
    setTimeout(async () => {
      await this.loadAsync();
    }, 5000);
  }

  async loadAsync() {
    let o = await ordersService.findOneAsync(this.id);
    if (o) {
      this.order = o;
    }
  }
}
